/**
 * SplitItemsModal - Modal để hiển thị và CRUD các split items
 *
 *
 */

import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { TableCustom } from '../../../../component/table/table-custom/TableCustom';
import { SplitServiceItem, MergedServiceRow } from '../../../utils/ServiceSplitHelper';
import { toast } from 'react-toastify';
import { DsDichVuChiDinhColumn } from '../ChiDinhDichVuColumn';

interface Props {
  show: boolean;
  onClose: () => void;
  mergedRow: MergedServiceRow;
  onUpdateItems: (updatedItems: SplitServiceItem[]) => void;
  categoriesRef: any;
  getObjectPriceFieldConfig: (objectTypeValue: any) => string | null;
  patientInfo?: any;
  configEditValue?: (field: string, value: any) => Record<string, any>;
}

export const SplitItemsModal: React.FC<Props> = ({
  show,
  onClose,
  mergedRow,
  onUpdateItems,
  categoriesRef,
  getObjectPriceFieldConfig,
  patientInfo,
  configEditValue,
}) => {
  const [splitItems, setSplitItems] = useState<SplitServiceItem[]>(mergedRow.splitItems);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const updateRowData = (index: number, field: string, value: any) => {
    const updatedItems = [...splitItems];

    if (field === 'attributes') {
      updatedItems[index] = {
        ...updatedItems[index],
        attributes: value,
      };
    } else {
      const editedValue = configEditValue?.(field, value);
      updatedItems[index] = {
        ...updatedItems[index],
        ...editedValue,
      };
    }

    setSplitItems(updatedItems);
  };

  const handleDelete = (selectedIndex = selectedRowIndex) => {
    if (selectedIndex === null) return;

    if (splitItems.length === 1) {
      toast.warning('Không thể xóa item cuối cùng');
      return;
    }

    const updatedItems = splitItems.filter((_, index) => index !== selectedIndex);
    setSplitItems(updatedItems);
    setSelectedRowIndex(null);
    toast.success('Đã xóa item');
  };

  const handleSave = () => {
    onUpdateItems(splitItems);
    onClose();
    toast.success('Đã lưu thay đổi');
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Chi tiết: {mergedRow.name} ({mergedRow.code}) - {splitItems.length} items
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <TableCustom
          columns={DsDichVuChiDinhColumn}
          data={splitItems}
          height={450}
          tableOptions={{
            updateRowData,
            listDoiTuong: categoriesRef?.current?.objectTypes || [],
            setSelectedRow: setSelectedRowIndex,
            handleDelete,
            patientInfo,
            getObjectPriceFieldConfig,
            // Flag to disable quantity editing in modal
            disableQuantityEdit: true,
            // Hide icon in modal
            onViewSplitItems: undefined,
          }}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Hủy
        </Button>
        <Button variant="primary" onClick={handleSave}>
          <i className="bi bi-floppy me-1"></i>
          Lưu
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
